export default "__VITE_ASSET__566d5504__"